import { useMemo } from "react";
import { EventBlock, HourLines, OffShade, TimeGutter, useDrop } from "@/components/calendar/Grid";
import { TOTAL_PX, dateKey, dayStatus, hm, layoutLanes, minutesAt, slotFromClick } from "@/lib/cal";
import { cn } from "@/lib/utils";

const StaffColumn = ({ s, date, appts, onSlot, onEvent, onMove }) => {
  const status = dayStatus(s, date);
  const drop = useDrop(({ id, offsetMin }, e) => onMove(id, { staff_id: s.id, start: `${dateKey(date)}T${hm(minutesAt(e, offsetMin))}` }));
  return (
    <div className="w-44 shrink-0 border-r last:border-r-0" data-testid={`day-col-${s.id}`}>
      <div className="sticky top-0 z-[15] flex h-14 flex-col justify-center border-b bg-card px-3">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: s.color }} />
          <span className="truncate text-sm font-semibold">{s.name}</span>
        </div>
        <span className="truncate text-[11px] text-muted-foreground">{status.label}</span>
      </div>
      <div className={cn("relative cursor-cell transition-colors", drop.over && "bg-primary/10")} style={{ height: TOTAL_PX }} {...drop.props}
        onClick={(e) => onSlot(s, `${dateKey(date)}T${slotFromClick(e)}`)} data-testid={`day-slot-${s.id}`}>
        <HourLines />
        <OffShade status={status} />
        {layoutLanes(appts).map(({ ev, lane, lanes }) => (
          <EventBlock key={ev.id} a={ev} lane={lane} lanes={lanes} color={s.color} onClick={onEvent} />
        ))}
      </div>
    </div>
  );
};

export const DayView = ({ date, staff, appts, onSlot, onEvent, onMove }) => {
  const byStaff = useMemo(() => appts.reduce((m, a) => ({ ...m, [a.staff_id]: [...(m[a.staff_id] || []), a] }), {}), [appts]);
  return (
    <div className="max-h-[calc(100vh-260px)] min-h-[420px] overflow-auto rounded-xl border bg-card" data-testid="day-view">
      <div className="flex min-w-max">
        <TimeGutter />
        {staff.map((s) => (
          <StaffColumn key={s.id} s={s} date={date} appts={byStaff[s.id] || []} onSlot={onSlot} onEvent={onEvent} onMove={onMove} />
        ))}
      </div>
    </div>
  );
};
